import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ParentService from "services/ParentsService";

export const getParents = createAsyncThunk(
  "parent/getParents",
  async (params, { rejectWithValue }) => {
    try {
      const response = await ParentService.getParents(params);
      console.log(response);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const downloadParentExcel = createAsyncThunk(
  "user/downloadParentExcel",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await ParentService.downalodParentExcel(data, params);
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const getMyStudents = createAsyncThunk(
  "parent/getMyStudents",
  async (params, { rejectWithValue }) => {
    try {
      const response = await ParentService.getMyStudents(params);
      console.log(response);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const deleteMyStudents = createAsyncThunk(
  "parent/deleteMyStudents",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      const response = await ParentService.deleteMyStudents(data, params);
      console.log(response);

      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const getSingleParent = createAsyncThunk(
  "parent/getSingleParent",
  async (params, { rejectWithValue }) => {
    try {
      const response = await ParentService.getSingleParent(params);
      console.log(response);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const getLatestParentName = createAsyncThunk(
  "parent/getLatestParentName",
  async (params, { rejectWithValue }) => {
    try {
      const response = await ParentService.getLatestParentName(params);
      console.log(response);

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const editParent = createAsyncThunk(
  "parent/editParents",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      console.warn("fksakfafsdfafafafas", data, params);
      const response = await ParentService.editParent(data, params);

      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const editBulkParentStatus = createAsyncThunk(
  "parent/editBulkParentStatus",
  async ({ data, status }, { rejectWithValue }) => {
    try {
      const response = await ParentService.editParentStatus(data, status);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const editMyStudentStatus = createAsyncThunk(
  "parent/editMyStudentStatus",
  async ({ data, params }, { rejectWithValue }) => {
    try {
      console.warn("fksakfas", data, params);
      const response = await ParentService.editMyStudentStatus(data, params);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);
export const editMyStudentBulkStatus = createAsyncThunk(
  "parent/editMyStudentStatus",
  async ({ data, status }, { rejectWithValue }) => {
    try {
      const response = await ParentService.editMyStudentBulkStatus(
        data,
        status
      );
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch academic year"
      );
    }
  }
);

const parentSlice = createSlice({
  name: "parents",
  initialState: {
    parents: {},
    singleParent: {},
    myStudents: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getParents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getParents.fulfilled, (state, action) => {
        state.loading = false;
        state.parents = action.payload;
      })
      .addCase(getParents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(downloadParentExcel.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(downloadParentExcel.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(downloadParentExcel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getMyStudents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMyStudents.fulfilled, (state, action) => {
        state.loading = false;
        state.myStudents = action.payload;
      })
      .addCase(getMyStudents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteMyStudents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteMyStudents.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteMyStudents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getLatestParentName.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getLatestParentName.fulfilled, (state, action) => {
        state.loading = false;
        state.latestParentName = action.payload.new_name;
      })
      .addCase(getLatestParentName.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getSingleParent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSingleParent.fulfilled, (state, action) => {
        state.loading = false;
        state.singleParent = action.payload;
      })
      .addCase(getSingleParent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(editParent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editParent.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(editParent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(editBulkParentStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editBulkParentStatus.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(editBulkParentStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { } = parentSlice.actions;
export default parentSlice.reducer;
